import { render } from "./GeneralInfo.vue?vue&type=template&id=432365cb&scoped=true"
const script = {}

import "./GeneralInfo.vue?vue&type=style&index=0&id=432365cb&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432365cb"]])

export default __exports__